import secondaryComponents from "../../../../../components/secondaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import { Outlet, useSearchParams } from "react-router-dom";

const MainLayout = () => {
  const [search] = useSearchParams();

  const connection_id = search.get("id");

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Chowdeck"
      description={"View and Manage Connections"}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.3 } }}
        className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
      >
        {connection_id ? (
          <div className="mb-4">
            <h4 className="mb-0">Manage API</h4>
          </div>
        ) : (
          <div className="mb-4">
            <h4 className="mb-0">Manage Chowdeck App</h4>
            <p>Connect & manage Chowdeck stores and API with Lumi Business</p>
          </div>
        )}
        <div>
          <Outlet />
        </div>
      </motion.div>
    </secondaryComponents.MetaSetter>
  );
};

export default MainLayout;
